<template>
    <div class="bg-yellow-50 shadow mt-5 p-5" id="transfer-receipt">
        <table class="w-full">
            <tbody>
            <tr>
                <td class="px-2 py-2 text-xs text-center font-bold" colspan="2">
                    <application-mark width="150" class="m-auto" style="-webkit-filter: grayscale(100%);"/>
                </td>
            </tr>
            <tr>
                <td class="px-2 py-2 text-xs text-center" colspan="2">
                    <hr/>
                </td>
            </tr>
            <td class="px-2 py-2 text-xs text-center font-bold" colspan="2">
                CONTA DE ORIGEM
            </td>
            <tr>
                <td class="px-2 py-2 text-sm font-bold">Nome</td>
                <td class="px-2 py-2 text-sm text-right">
                    {{ account.customer.name }}
                </td>
            </tr>
            <tr>
                <td class="px-2 py-2 text-sm font-bold">Agência</td>
                <td class="px-2 py-2 text-sm text-right">
                    {{ content.data.origem.agencia }}
                </td>
            </tr>
            <tr>
                <td class="px-2 py-2 text-sm font-bold">Conta</td>
                <td class="px-2 py-2 text-sm text-right">
                    {{ content.data.origem.conta }}-{{ content.data.origem.contaDigito }}
                </td>
            </tr>
            <tr>
                <td class="px-2 py-2 text-xs text-center" colspan="2">
                    <hr/>
                </td>
            </tr>
            <tr>
                <td class="px-2 py-2 text-xs text-center font-bold" colspan="2">
                    CONTA DE DESTINO
                </td>
            </tr>
            <tr>
                <td class="px-2 py-2 text-sm text-center" colspan="2">
                    <span class="font-bold">{{ content.data.favorecido.nome }}</span><br/>
                    <span class="text-3xl font-extrabold">
                                        R$ {{ content.data.vlrTransacao | currency }}</span>

                </td>
            </tr>
            <tr>
                <td class="px-2 py-2 text-sm font-bold">Documento</td>
                <td class="px-2 py-2 text-sm text-right">{{ content.data.favorecido.documentoFederal }}
                </td>
            </tr>
            <tr>
                <td class="px-2 py-2 text-sm font-bold">Instituição/ISPB</td>
                <td class="px-2 py-2 text-sm text-right">{{ content.data.favorecido.numeroBanco }}</td>
            </tr>
            <tr>
                <td class="px-2 py-2 text-sm font-bold">Agência</td>
                <td class="px-2 py-2 text-sm text-right">{{ content.data.favorecido.conta.agencia }}</td>
            </tr>
            <tr>
                <td class="px-2 py-2 text-sm font-bold">Conta</td>
                <td class="px-2 py-2 text-sm text-right">
                    {{ content.data.favorecido.conta.conta }}-{{
                        content.data.favorecido.conta.contaDigito
                    }}
                </td>
            </tr>
            <tr>
                <td class="px-2 py-2 text-sm font-bold">Tipo transferência</td>
                <td class="px-2 py-2 text-sm text-right">{{
                        parseType(content.data.tipoTransferencia)
                    }}
                </td>
            </tr>
            <tr>
                <td class="px-2 py-2 text-sm font-bold">Data e hora</td>
                <td class="px-2 py-2 text-sm text-right">{{ content.data.created | smallDateTime }}</td>
            </tr>
            <tr>
                <td class="px-2 py-2 text-xs text-center" colspan="2">
                    <hr/>
                </td>
            </tr>
            <tr>
                <td class="px-2 py-2 text-center" colspan="2">
                    <span class="text-bold">Autenticação</span><br/>
                    <span class="text-xs">{{ content.data.codigoTransacao }}</span>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import ApplicationMark from "../../Jetstream/ApplicationMark";

export default {
    props: {
        content: {
            type: Object,
            default: {}
        },
        account: {
            type: Object,
            default: {}
        }
    },
    methods: {
        parseType: function (type) {
            switch (type) {
                case 'ted':
                    return 'ENVIO TED';
                case 'p2p':
                case 'transferencia':
                    return 'ENTRE CONTAS DÉBITO';
                default:
                    return type;
            }
        }
    },
    data() {
        return {}
    },
    components: {
        ApplicationMark
    },
}
</script>
